import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LoaderService, LoaderState } from '@pacifico/services/local/my-loader.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
	show = false;
	@Input() forceShow!: boolean;

	private subscription: Subscription = new Subscription();

	constructor(private loaderService: LoaderService, private cd: ChangeDetectorRef) {}

	ngOnInit(): void {
		this.subscription = this.loaderService.loaderState.subscribe((state: LoaderState) => {
			this.show = state.show;
			this.cd.detectChanges();
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
